import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { PartialGradeCommand } from '../models/partial-grade.command.model';
import { PartialGrade } from '../models/partial-grade.model';

export class SetPartialGrade {
    static readonly type = '[PartialGrade] SetPartialGrade';

    constructor(public payload: PartialGrade) {}
}

export class UnsetPartialGrade {
    static readonly type = '[PartialGrade] UnsetPartialGrade';
}

export class FetchPartialGrade {
    static readonly type = '[PartialGrade] FetchPartialGrade';

    constructor(public payload: string) {}
}

export class FetchPartialGradeSuccess {
    static readonly type = '[PartialGrade] FetchPartialGradeSuccess';

    constructor(public payload: PartialGrade) {}
}

export class FetchPartialGradeFailure {
    static readonly type = '[PartialGrade] FetchPartialGradeFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddPartialGrades {
    static readonly type = '[PartialGrade] AddPartialGrades';

    constructor(public payload: PartialGrade[]) {}
}

export class UpdatePartialGrade {
    static readonly type = '[PartialGrade] UpdatePartialGrade';

    constructor(public payload: PartialGrade) {}
}

export class UpdatePartialGradeSuccess {
    static readonly type = '[PartialGrade] UpdatePartialGradeSuccess';

    constructor(public payload: PartialGrade) {}
}

export class UpdatePartialGradeFailure {
    static readonly type = '[PartialGrade] UpdatePartialGradeFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeletePartialGrade {
    static readonly type = '[PartialGrade] DeletePartialGrade';

    constructor(public payload: string) {}
}

export class DeletePartialGradeSuccess {
    static readonly type = '[PartialGrade] DeletePartialGradeSuccess';

    constructor(public payload: string) {}
}

export class DeletePartialGradeFailure {
    static readonly type = '[PartialGrade] DeletePartialGradeFailure';

    constructor(public payload: string) {}
}

export class SetPartialGrades {
    static readonly type = '[PartialGrade] SetPartialGrades';

    constructor(public payload: PartialGrade[]) {}
}

export class FetchPartialGrades {
    static readonly type = '[PartialGrade] FetchPartialGrades';
}

export class FetchPartialGradesSuccess {
    static readonly type = '[PartialGrade] FetchPartialGradesSuccess';
}

export class FetchPartialGradesFailure {
    static readonly type = '[PartialGrade] FetchPartialGradesFailure';
}

export class BulkUpdatePartialGrades {
    static readonly type = '[PartialGrade] BulkUpdatePartialGrades';

    constructor(public payload: PartialGradeCommand[]) {}
}

export class BulkUpdatePartialGradesSuccess {
    static readonly type = '[PartialGrade] BulkUpdatePartialGradesSuccess';

    constructor(public payload: PartialGrade[]) {}
}

export class BulkUpdatePartialGradesFailure {
    static readonly type = '[PartialGrade] BulkUpdatePartialGradesFailure';

    constructor(public payload: string) {}
}

export class BulkUpdatePartialGradesStatus {
    static readonly type = '[PartialGrade] BulkUpdatePartialGradesStatus';

    constructor(
        public payload: {
            entities: string[];
            status: string;
        }
    ) {}
}

export class BulkUpdatePartialGradesStatusSuccess {
    static readonly type = '[PartialGrade] BulkUpdatePartialGradesStatusSuccess';

    constructor(public payload: PartialGrade[]) {}
}

export class BulkUpdatePartialGradesStatusFailure {
    static readonly type = '[PartialGrade] BulkUpdatePartialGradesStatusFailure';

    constructor(public payload: string) {}
}
